import { MAX_BOOST_TERMS, MIN_RELEVANT_BOOST_COUNT, TEMPLATE_INTERACTION_TYPE } from 'shared/experiments/DesignBoost/constants'

// Normalize the weights of the results so that all boosts total 1
// Limit to top 25 terms total (keywords + categories combined) aka MAX_BOOST_TERMS

// Exclude results where the count is 1 or less. Split into keywords and categories.
export const normalizeTemplateInteractionsToBoosts = (
  templateInteractions: VP.DesignPersonalization.Models.DesignPersonalizationContextService.TemplateInteraction[],
): State.BoostsState => {
  const boostedTerms: { value: string; weight: number; subtype: string }[] = []

  const groupedTemplateInteractions = templateInteractions.reduce(
    (acc, interaction) => {
      const key = `${interaction.subtype}-${interaction.data}`
      const multiplier = interaction.type === TEMPLATE_INTERACTION_TYPE.STUDIO_TRANSITION ? 2 : 1
      const weightedValue = interaction.count * multiplier

      acc[key] = (acc[key] || 0) + weightedValue
      return acc
    },
    {} as Record<string, number>,
  )

  for (const [key, count] of Object.entries(groupedTemplateInteractions)) {
    const [subtype, value] = key.split('-')

    if (count >= MIN_RELEVANT_BOOST_COUNT) {
      boostedTerms.push({ value, weight: count, subtype })
    }
  }

  // Sort by weight (count) in descending order and take top 25
  const topTerms = boostedTerms.sort((a, b) => b.weight - a.weight).slice(0, MAX_BOOST_TERMS)

  // Recalculate total count for normalization
  const topTermsTotal = topTerms.reduce((sum, term) => sum + term.weight, 0)

  const boostedKeywords: Gallery.ContentQuery.Boost[] = []
  const boostedCategories: Gallery.ContentQuery.Boost[] = []

  topTerms.forEach((term) => {
    const fixedNormalizedWeight = (term.weight / topTermsTotal).toFixed(3)

    if (fixedNormalizedWeight === '0.000') {
      return
    }

    if (term.subtype === 'keyword') {
      boostedKeywords.push({
        value: term.value,
        weight: Number(fixedNormalizedWeight),
      })
    } else if (term.subtype === 'category') {
      boostedCategories.push({
        value: term.value,
        weight: Number(fixedNormalizedWeight),
      })
    }
  })

  return {
    boostedKeywords,
    boostedCategories,
  }
}
